// firebase.js
import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, isSupported } from '@firebase/messaging';
import {
  supportsServiceWorker,
  supportsNotifications,
  checkFirebaseMessagingSupport
} from './browserSupport';

const firebaseConfig = {
  apiKey: "AIzaSyD-VBIK0B_OzqSK2H2UtrECtOX5dSEeC2Y",
  authDomain: "flyspa-219212.firebaseapp.com",
  databaseURL: "https://flyspa-219212.firebaseio.com",
  projectId: "flyspa-219212",
  storageBucket: "flyspa-219212.firebasestorage.app",
  messagingSenderId: "1018324401138",
  appId: "1:1018324401138:web:ae647cc00c74556b8b896b",
  measurementId: "G-ZT5K324CMS",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export const isMessagingSupported = async () => {
    try {
        const supportCheck = await checkFirebaseMessagingSupport();
        if (!supportCheck.supported) {
            console.log(`Firebase messaging not supported: ${supportCheck.reason}`);
            return false;
        }

        return await isSupported();
    } catch (error) {
        console.error("Firebase messaging not supported:", error);
        return false;
    }
};

let messagingInstance = null;

try {
    if (supportsServiceWorker() && supportsNotifications()) {
        messagingInstance = getMessaging(firebaseApp);
    } else {
        console.log("Service workers or notifications not supported, Firebase messaging will be disabled");
    }
} catch (error) {
    console.error("Error initializing Firebase messaging:", error);
}

export const messaging = messagingInstance;

export const generateToken = async () => {
    try {
        const supportCheck = await checkFirebaseMessagingSupport();
        if (!supportCheck.supported) {
            console.log(`Firebase messaging not supported: ${supportCheck.reason}`);
            return null;
        }

        if (!messaging) {
            console.log("Firebase messaging instance is not available");
            return null;
        }

        try {
            const permission = await Notification.requestPermission();
            console.log("Notification permission:", permission);

            if (permission === "granted") {
                try {
                    // Get token with error handling
                    const token = await getToken(messaging, {
                        vapidKey: "BOh5fqS8SdKeguQvvPX7_ak6sO-l9XNHOugU_JxpthLNJPUGhM_tSJ_2VJ0fl4x3O9cCKzpmHAoeeVSGAb1RLJU",
                    });

                    if (token) {
                        console.log("Firebase token generated successfully");
                        localStorage.setItem('firebaseToken', token);
                        return token;
                    } else {
                        console.log("No token was generated");
                    }
                } catch (tokenError) {
                    console.error("Error getting Firebase token:", tokenError);
                    // Store information about the error for debugging
                    localStorage.setItem('firebaseTokenError', JSON.stringify({
                        message: tokenError.message,
                        code: tokenError.code,
                        stack: tokenError.stack,
                        browser: navigator.userAgent
                    }));
                }
            } else {
                console.log(`Notification permission ${permission}`);
            }
        } catch (permissionError) {
            console.error("Error requesting notification permission:", permissionError);
        }
    } catch (error) {
        console.error("Error in generateToken:", error);
    }

    return null;
};